/**
 * @desc: 图表 UI 服务
 */
import _ from 'lodash';
const Emitter = require('../../emitter').default;
const store = require('../../../reducers').default;
const DataChartAction = require('../../../reducers/dataChart').default;
import { message } from 'antd';
let _xAxisData = [];
let _seriesData = [];
let _chartName = 'untitled';
let _chartType = 'table';
let _xAxisName = 'type';
let _yAxisName = 'data';
let _maxXAixsDataLength = 200;
//图例最多10条
let _maxLegendLength = 10;
const throttledWarnReachMaxXAxis = _.throttle(function () {
    message.warning(store.getState().intlr.messages['MESSAGE.CHART.REATCHMAXXAXISDATA'].replace('{0}', _maxXAixsDataLength));
}, 3500);
const throttledWarnReachMaxLegend = _.throttle(function () {
    message.warning(store.getState().intlr.messages['MESSAGE.CHART.REATCHMAXLENGEND'].replace('{0}', _maxLegendLength));
}, 3500);
export const DataChart = {
    id: 'data.chart',
    open: () => {
        store.dispatch(DataChartAction.actions.open());
    },
    close: () => {
        store.dispatch(DataChartAction.actions.close());
    },
    clear() {
        console.warn('clear');
        _xAxisData = [];
        _seriesData = [];
        Emitter.emit('clearChart');
    },
    setType: (type) => {
        _chartType = type;
        Emitter.emit('setChartType', type);
    },
    set chartName(data) {
        _chartName = data;
        Emitter.emit('setChartName', _chartName);
    },
    get chartName() {
        return _chartName;
    },
    getAllData() {
        return {
            chartName: _chartName,
            chartType: _chartType,
            xAxisName: _xAxisName,
            yAxisName: _yAxisName,
            xAxisData: _xAxisData,
            seriesData: _seriesData,
        };
    },
    setAxisName(xAxisName, yAxisName) {
        _xAxisName = xAxisName;
        _yAxisName = yAxisName;
        Emitter.emit('setAxisName', _xAxisName, _yAxisName);
    },
    //  _xAxisData:[xData1, xData2, ...]
    // _seriesData:[{
    //     name: type1,
    //     data:[
    //         [xData1, yData1]
    //     ]
    // }]
    inputData(type, xData, yData) {
        //type为空或者全是空格设为一个空格
        if (type.match(/^[ ]*$/)) {
            type = ' ';
        }
        if (_xAxisData.indexOf(xData) === -1) {
            if (_xAxisData.length === _maxXAixsDataLength) {
                // 数据图表窗口没显示时，数据过多提示也要提示，所以写于此
                throttledWarnReachMaxXAxis();
                return;
            }
            _xAxisData.push(xData);
        }
        if (_seriesData.length === 0) {
            _seriesData.push({ name: type, data: [[xData, yData]] });
        }
        else {
            for (let i = 0; i < _seriesData.length; i++) {
                const seriesItem = _seriesData[i];
                if (seriesItem.name === type) {
                    for (let i = 0; i < seriesItem.data.length; i++) {
                        const data = seriesItem.data[i];
                        if (data[0] === xData) {
                            data[1] = yData;
                            break;
                        }
                        if (i === seriesItem.data.length - 1) {
                            seriesItem.data.push([xData, yData]);
                        }
                    }
                    break;
                }
                if (i === _seriesData.length - 1) {
                    if (_seriesData.length === _maxLegendLength) {
                        throttledWarnReachMaxLegend();
                        return;
                    }
                    _seriesData.push({ name: type, data: [[xData, yData]] });
                }
            }
        }
        Emitter.emit('updateData', _xAxisData, _seriesData);
    },
    setMaxXAixsDataLength: (data) => {
        _maxXAixsDataLength = data;
    },
    destroy: () => {
        DataChart.close();
        DataChart.clear();
    }
};
Emitter.on('DestroyDataChart', DataChart.destroy);
